<template>
  <div :data-component-name="$options.name" class="img90tit10 graphik_bold">
    <a
      :href="content.internalUrl"
      :data-tag="`${jel_getNomRouteCourante()} - ${content.titre.replace(/&nbsp;/g, ' ')} - ${
        content.dataTag
      }`"
      class="offre-speciale"
    >
      <div class="h-100">
        <img v-lazy="jel_getFichierSrc(content.image)" class="w-100 image" :alt="content.titre" />
        <div class="img90tit10_text_content">
          <p v-if="content.surTitre" v-html="content.surTitre"></p>
          <div class="img90tit10_titre graphik_bold" v-html="content.titre"></div>
          <p v-if="content.sousTitre" v-html="content.sousTitre"></p>
        </div>
      </div>
      <div v-html="content.texte"></div>
    </a>
  </div>
</template>

<script>
export default {
  name: 'MediaImageImg90tit10',
  props: { content: { type: Object, required: true } },
  data() {
    return {};
  },
  computed: {
    classObject() {
      return {
        rounded: this.content.coinArrondi,
      };
    },
    styleObject() {
      return {
        'background-color':
          this.content.fondCouleur?.field === 'couleurEdit'
            ? this.content.fondCouleur.secBgThemeColor
            : null,
      };
    },
  },
  created() {},
  methods: {},
};
</script>

<style lang="scss" scoped>
.row {
  background-position: center;
  background-repeat: no-repeat;
}
.image {
  border-top-left-radius: ms(2);
  border-top-right-radius: ms(2);
  height: 80%;
  object-fit: cover;
  object-position: center left;
  display: block;
}

.img90tit10 {
  height: 220px; //TODO: Voir si cette valeur pourrait etre defini ailleurs
}

.img90tit10_titre {
  text-align: center;
  margin: 1rem;
  @include ms-respond(font-size, 2);
  color: #303030;
}

.img90tit10_text_content {
  height: 20%;
  display: flex;
  justify-content: center;
  align-items: center;
}

.row.bgcover {
  background-size: cover;
}
.container-fluid {
  padding: 0;
}

.img90tit10 a {
  text-decoration: none;
  color: #2c3e50;
}

.main-bingo div .img90tit10_titre {
  line-height: 1em;
}
</style>
